module.exports = __webpack_public_path__ + "static/media/android.d05a88e5.svg";